export const removeInlineSeo = () => {
  if (typeof document !== 'object') return '';
  const seoH1 = document.querySelector('.seo-only-h1');

  if (seoH1) seoH1.remove();
};

export const inBrowser = () => {
  return typeof window !== 'undefined';
};
